<template>
  <div class="right-chart-1" id="right-chart-1"></div>
</template>

<script>
import { queryctxypm } from '@/api/modules/dataView.js'
export default {
  name: 'LeftChart3',
  props: {
    date: {
      type: Object,
      default: () => {
        return {
          startdate: '',
          enddate: '',
        }
      },
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const container = document.getElementById('right-chart-1')
      this.chart = this.$echarts.init(container)
      const apiData = await queryctxypm(this.date)
      let xDatas = []
      let zsyDatas = []
      let zcbDatas = []
      let zsrDatas = []
      apiData.forEach(item => {
        xDatas.push(item.org_name)
        zsyDatas.push(item.sum_lszsy ? (item.sum_lszsy / 10000).toFixed(6) : 0)
        zcbDatas.push(item.sum_lszcb ? (item.sum_lszcb / 10000).toFixed(6) : 0)
        zsrDatas.push(item.zsr ? (item.zsr / 10000).toFixed(6) : 0)
      })
      const options = {
        title: {
          text: 'CT效益列表',
          textStyle: {
            color: '#fff',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {
          right: '0',
          textStyle: {
            color: '#fff',
          },
          data: ['总成本', '总收入', '总收益'],
        },
        grid: {
          top: 80,
          bottom: 40,
        },
        xAxis: [
          {
            type: 'category',
            axisLabel: {
              color: '#fff',
            },
            data: xDatas,
          },
        ],
        yAxis: {
          name: '单位：万元',
          nameTextStyle: {
            color: '#fff',
          },
          type: 'value',
          axisLabel: {
            color: '#fff',
          },
          boundaryGap: [0, 0.01],
        },
        series: [
          {
            name: '总成本',
            type: 'bar',
            data: zcbDatas,
          },
          {
            name: '总收入',
            type: 'bar',
            data: zsrDatas,
          },
          {
            name: '总收益',
            type: 'bar',
            data: zsyDatas,
          },
        ],
      }
      this.chart.setOption(options)
    },
  },
}
</script>

<style lang="scss" scoped>
.right-chart-1 {
  width: 100%;
  height: 37%;
  display: flex;
  flex-direction: column;
}
</style>
